module.exports = __webpack_public_path__ + "static/media/Oliva-Serif-Font.ced2641d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Oliva-Serif-Font.woff
// module id = 3450
// module chunks = 68